import { IgButton } from "@intelligems/ig-theme/IgButton";
import { RuleExperiencesDialog } from "../rules/RuleExperiencesDialog";
import { experiencesLabel } from "./ruleSaveApplyState";

/**
 * "Apply your changes?" — leaving a rule some experience uses while its draft
 * is unapplied. Edits are already saved, so the choice is only what shoppers
 * get: the edits (Apply), the live version (Discard), or the edits as a rule
 * of their own.
 */
export const RuleLeaveUnappliedDialog = ({
  open,
  usedInCount,
  isBusy,
  applyDisabledHint,
  saveAsNewDisabled,
  onClose,
  onSaveAsNew,
  onDiscard,
  onApply,
}: {
  open: boolean;
  usedInCount: number;
  isBusy: boolean;
  applyDisabledHint: string | undefined;
  saveAsNewDisabled: boolean;
  onClose: () => void;
  onSaveAsNew: () => void;
  onDiscard: () => void;
  onApply: () => void;
}) => (
  <RuleExperiencesDialog
    open={open}
    title="Apply your changes?"
    description={`This rule is live in ${experiencesLabel(usedInCount)}. Your edits are saved as a draft, but shoppers won't see them until you apply.`}
    experiences={[]}
    onClose={onClose}
    maxWidth="sm"
    actions={
      <>
        <IgButton
          color="link"
          disabled={isBusy || saveAsNewDisabled}
          onClick={onSaveAsNew}
          sx={{
            mr: "auto !important",
            ml: "0 !important",
            whiteSpace: "nowrap",
          }}
        >
          Save as a new rule
        </IgButton>
        <IgButton
          color="secondary"
          disabled={isBusy}
          onClick={onDiscard}
          sx={{ whiteSpace: "nowrap" }}
        >
          Discard changes
        </IgButton>
        <IgButton
          color="primary"
          disabled={isBusy || applyDisabledHint !== undefined}
          onClick={onApply}
          sx={{ whiteSpace: "nowrap" }}
        >
          {`Apply to ${experiencesLabel(usedInCount)}`}
        </IgButton>
      </>
    }
  />
);
